import { HTTP } from '../services'

export default new (class LeadEventService {
  getLeadEventByLeadId(leadId) {
    return HTTP.get('/v1/leads/' + leadId + '/lead-events')
  }

  updateLeadEventData(leadEventId, data) {
    return HTTP.put('/v1/lead-event/' + leadEventId, data)
  }

  addDelegate(leadEventId, leadId) {
    return HTTP.post('/v1/lead-event/' + leadEventId + '/lead/' + leadId + '/delegates')
  }

  removeDelegate(leadEventId, leadId, delegateLeadId) {
    return HTTP.delete('/v1/lead-event/' + leadEventId + '/lead/' + leadId + '/delegates/' + delegateLeadId)
  }

  makeDelegateOwner(leadEventId, leadId, delegateLeadId) {
    return HTTP.put('/v1/lead-event/' + leadEventId + '/lead/' + leadId + '/delegates/' + delegateLeadId + '/make-owner')
  }

  getDelegates(leadEventId, leadId) {
    return HTTP.get('/v1/lead-event/' + leadEventId + '/delegates')
  }

  updateLeadEventMultiStepData(leadEventId, data) {
    return HTTP.put('/v1/lead-event/' + leadEventId + '/multi-step', data)
  }

  updateEventSession(leadEventId, data) {
    return HTTP.put('/v1/lead-event/' + leadEventId + '/session/update', data)
  }

  createEventSession(leadEventId, data) {
    return HTTP.post('/v1/lead-event/' + leadEventId + '/session/create', data)
  }

  updateCorporateLeadEvent(leadEventId, data) {
    return HTTP.post('/v1/lead-event/' + leadEventId + '/update-corporate', data)
  }

  crateLeadEvent(leadId, data) {
    return HTTP.post('/v1/leads/' + leadId + '/lead-event', data)
  }

  mergeEvents(primaryLeadEvent, secondaryLeadEvent) {
    return HTTP.put(
      '/v1/lead-event/' +
      primaryLeadEvent.id +
      '/merge/' +
      secondaryLeadEvent.id
    )
  }

  getLeadEventData(leadEventId) {
    return HTTP.get('/v1/lead-event/' + leadEventId)
  }

  timeline(leadEventId, timezone) {
    return HTTP.get(
      '/v1/lead-event/' + leadEventId + '/timeline?timezone=' + timezone
    )
  }

  requeueEvents(leadEventId, tracker_id, type) {
    return HTTP.post('/v1/lead-event/' + leadEventId + '/requeue_events', {
      tracker_id,
      type
    })
  }

  syncFromHubspot(leadId) {
    return HTTP.post('/v1/leads/' + leadId + '/sync-deals-from-hubspot')
  }

  setVenueAvailability(leadEventId, venueId, isAvailable) {
    return HTTP.post(
      '/v1/lead-event/' + leadEventId + '/venue/' + venueId + '/availability',
      { is_available: isAvailable }
    )
  }

  uploadQuote(leadEventId, form) {
    return HTTP.post('/v1/lead-event/' + leadEventId + '/upload-quote', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  removeQuote(leadEventId, venueId) {
    return HTTP.delete('/v1/lead-event/' + leadEventId + '/quote/' + venueId)
  }

  getQuoteDownloadUrl(leadEventId, venueId) {
    return HTTP.get(
      '/v1/lead-event/' + leadEventId + '/quote/' + venueId + '/download-url'
    )
  }

  saveQuoteLink(leadEventId, venueId, link) {
    return HTTP.post(
      '/v1/lead-event/' + leadEventId + '/quote/' + venueId + '/link',
      { quote_link: link }
    )
  }

  // Get all quotes for a lead event with timeline data
  getQuotes(leadEventId) {
    return HTTP.get('/v1/lead-event/' + leadEventId + '/quotes')
  }

  // Create a new quote for a lead event
  createQuote(leadEventId, formData) {
    return HTTP.post('/v1/lead-event/' + leadEventId + '/quotes', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  // Update an existing quote
  updateQuote(leadEventId, quoteId, data) {
    return HTTP.put('/v1/lead-event/' + leadEventId + '/quotes/' + quoteId, data)
  }

  // Update deal pipeline stage of a lead event.
  updateDealStage(leadEventId, dealStageId) {
    return HTTP.post('/v1/lead-event/' + leadEventId + '/update-deal-stage', {
      pipeline_stage_id: dealStageId
    })
  }

  // Send venue brochures via email
  sendBrochureRequestEmail(leadEventId, data) {
    return HTTP.post(
      `/v1/lead-event/` + leadEventId + `/send-venue-brochure`,
      data
    )
  }

  getEventLocations(country) {
    return HTTP.get('/v1/lead-event/event-locations?country=' + country)
  }

  deletePreDealEvent(leadEventId, initiatedBy) {
    return HTTP.delete('/v1/lead-event/' + leadEventId, { data: { initiated_by: initiatedBy } })
  }

  async getProposalQualifiedVenues(leadEventId) {
    console.log('Fetching proposal qualified venues for leadEventId:', leadEventId);
    try {
        const response = await HTTP.get('/v1/lead-event/' + leadEventId + '/proposal-qualified-venues');
        return response.data;
    } catch (error) {
        console.log('Error fetching proposal qualified venues:', error);
        throw error;
    }
  }
})()
